// @ts-check
import { combineReducers } from 'redux';
import pageData from 'shared/reducers/PageDataReducer';
import flashMessage from 'shared/reducers/FlashMessageReducer';
import session from './SessionReducer';
import currentAgent from './CurrentAgentReducer';
import agentContext from './AgentContextReducer';
import referringProviders from './ReferringProvidersReducer';
import referringLocations from './ReferringLocationsReducer';
import referralQuestionnaire from './ReferralQuestionnaireReducer';
import ReferralDashboardReducer from 'shared/reducers/ReferralProfiles/ReferralDashboardReducer';
import newReceivedReferrals from './NewReceivedReferralsReducer';
import referrals from './ReferralsReducer';
import payers from 'shared/reducers/PayersReducer';
import { geographicReducer } from 'agent_portal/actions/Geographic';
import { reducer as formReducer } from 'redux-form';
import ModalsReducer from 'shared/reducers/ModalsReducer';
import calendar from './CalendarReducer';
import costEstimate from './CostEstimateReducer';
import configuration from './ConfigurationReducer';
import ReferralWizardReducer from './ReferralWizardReducer';

const combinedReducers = combineReducers({
  configuration,
  pageData,
  calendar,
  costEstimate,
  flashMessage,
  session,
  agentContext,
  currentAgent,
  referringProviders,
  referringLocations,
  referralQuestionnaire,
  referralDashboardResults: ReferralDashboardReducer,
  referralWizard: ReferralWizardReducer,
  referrals,
  newReceivedReferrals,
  payers,
  geographic: geographicReducer,
  form: formReducer.plugin({
    referralQuestionnaire: (state, action) => {
      switch (action.type) {
        case 'REQUESTING_REFERRAL_QUESTIONNAIRE':
          return undefined;
        default:
          return state;
      }
    },
  }),
  activeModal: ModalsReducer,
});

export default function(state, action) {
  return combinedReducers(state, action);
}
